export const trackGtmEvent = (eventName: string, params?: Record<string, unknown>) => {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  window.dataLayer.push({
    application_version: import.meta.env.VITE_APPLICATION_VERSION,
    environment_server: import.meta.env.VITE_ENVIRONMENT_SERVER,
    environment_type: import.meta.env.VITE_ENVIRONMENT_TYPE,
    build_type: import.meta.env.VITE_ENVIRONMENT_TYPE,
    event: eventName,
    ...params,
  });
};


